import { ExternalLinkIcon } from 'lucide-react'

import { ButtonGroup, Modal } from 'slab'

interface WhenDoesBillingHappenModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function WhenDoesBillingHappenModal ({
  open,
  onOpenChange,
}: WhenDoesBillingHappenModalProps) {
  return (
    <Modal open={open} onOpenChange={onOpenChange}>
      <Modal.Header>
        <Modal.Title>When does billing happen?</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          You'll be billed twice per month - once on the 1st for platform fees, and once on the 13th for healthcare costs.
        </p>
        <p>
          Platform fees will both be finalized and paid on the 1st of the month, while healthcare costs are finalized on the 13th but paid on the 15th. The 2-day delay allows for lead time to ensure your bank account has enough funds to cover the costs.{' '}
          <a
            href='https://support.thatch.com/invoices-and-billing'
            target='_blank'
            rel='noopener noreferrer'
            className='inline-flex items-center gap-1 text-thatch-purple-secondary hover:text-thatch-purple-primary underline'
          >
            Learn more
            <ExternalLinkIcon className='w-4 h-4' />
          </a>
          .
        </p>
      </Modal.Body>
      <Modal.Footer>
        <ButtonGroup>
          <Modal.Button variant='primary'>
            Close
          </Modal.Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  )
}
